import React from 'react'
import { useHistory, withRouter } from 'react-router-dom';
import { hasCapabilitySupport } from '../../../app/Capabilities';
import Page from '../../../base/Page';
import Button from '../../../components/Button';
import { TABLE_RELATION_TYPE_ONE_TO_MANY } from '../../../constants/Constants';
import { OBJECT_TYPE_ACCOUNT, OBJECT_TYPE_BLOG_CATEGORY, OBJECT_TYPE_BLOG_POST, OBJECT_TYPE_CONTACT, OBJECT_TYPE_PRODUCT, OBJECT_TYPE_STORE, OBJECT_TYPE_SUPPLIER, OBJECT_TYPE_TERMINAL } from "../../../constants/ObjectTypes";
import Api, { createApiWithLang } from '../../../session/Api';
import ItemTemplate from '../../../templates/ItemTemplate';
import TableTemplate from '../../../templates/TableTemplate';
import { TranslateBanner } from '../../../templates/translate/translate-banner';
import Util from '../../../util/Util';
import AllSubsidiaryReportView from '../../accounting-reports/AllSubsidiaryReportView';
import StockFlowListView from '../../stock-flow/StockFlowListView';
import TransactionListView from '../../transaction/TransactionListView';


class BlogCategoriesDetailPage extends Page {

    api = Api;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            itemResult: undefined,
            lang: "EN"
        }
    }

    isCreating() {
        return this.getPathParams().itemId == "new";
    }

    onPageStart() {
        this.callPageApi(listener => {
            if (this.isCreating()) {
                this.api.getItemCreator(OBJECT_TYPE_BLOG_CATEGORY, listener)
            } else {
                this.api.getItem(OBJECT_TYPE_BLOG_CATEGORY, this.getPathParams().itemId, listener)
            }
        }, payload => ({
            itemResult: payload
        }))
    }

    setLang(lang) {
        this.setState({ lang }, () => {
            this.api = (!Util.isStringExists(lang) || lang === "EN") ? Api : createApiWithLang(lang);
            this.onPageStart();
        })
    }

    hasTranslation() {
        return hasCapabilitySupport("translationSupport") && this.state.itemResult.translationSupport;
    }

    getLayout() {
        return (<>
            {this.hasTranslation() && <TranslateBanner lang={this.state.lang} setLang={this.setLang.bind(this)} />}
            <div className="main-content">
                <div key={"blog-category-item-lang-" + this.state.lang}>
                    {ItemTemplate.renderTemplate({
                        objectType: OBJECT_TYPE_BLOG_CATEGORY,
                        itemResult: this.state.itemResult,
                        pagePath: "/blog-categories/",
                        history: this.props.history,

                        lang: this.state.lang
                    })}
                </div>
            </div>
        </>)
    }

}

export default withRouter(BlogCategoriesDetailPage);